var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-[0.9em] h-[0.9em] text-sm",
    viewBox: "-3 -3 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9822 10.0795C16.7293 12.0087 15.782 13.7797 14.3175 15.0608C12.853 16.342 10.9719 17.0455 9.02611 17.0397C7.08036 17.0339 5.20342 16.3191 3.74665 15.0292C2.28988 13.7393 1.35315 11.9627 1.11181 10.032C0.870466 8.10127 1.34106 6.14876 2.43549 4.53997C3.52993 2.93118 5.17317 1.7764 7.05763 1.29181C8.94208 0.807216 10.9385 1.02602 12.6733 1.90728C14.4081 2.78853 15.7622 4.27182 16.4822 6.07946M16.9822 1.07946L16.9822 6.07946L11.9822 6.07946",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRotate);
export default __webpack_public_path__ + "static/media/arrow-rotate.a098ad1b5f90b646f6ac0a6ed1c0c943.svg";
export { ForwardRef as ReactComponent };